import _ from "lodash";
import React, { useState } from "react";

import { AttachmentList } from "Attachment";
import FullScreenLoader from "UIComponents/FullScreenLoader";

import classes from "./GPTVision.scss";
import { connect } from "react-redux";

import { getAIResponse } from "modules/Services";

// Design system
import { IconButton, TextAreaInput, Modal } from "@toddle-edu/ds-web";
import { SendFilled } from "@toddle-edu/ds-icons";
import GPTVisionCost from "./GPTVisionCost";

const styles = {};

const GPTVision = ({ getAIResponse, onModalClose }) => {
  const [attachments, setAttachments] = useState([]);
  const [query, setQuery] = useState("");
  const [content, setContent] = useState("");
  const [metricsId, setMetricsId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const imageUrls = [];

  _.forEach(attachments, ({ url, type }) => {
    if (type === "IMAGE") {
      imageUrls.push({
        type: "image_url",
        image_url: url,
      });
    }
  });

  const onSendMessage = async () => {
    setMetricsId(null);
    setIsLoading(true);
    const { content, usageMetricsId } = await getAIResponse({
      variables: {
        input: {
          model: "gpt-4-vision-preview",
          maxTokens: 4000,
          stream: false,
          messages: [
            {
              role: "user",
              content: [
                {
                  type: "text",
                  text: query,
                },
                ...imageUrls,
              ],
            },
          ],
        },
      },
      onDownloadProgress: ({ content, usageMetricsId }) => {
        setContent(content);
      },
    });

    setMetricsId(usageMetricsId);
    setQuery("");
    setIsLoading(false);
  };

  const onKeyDown = e => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  return (
    <>
      <Modal height="75vh" width="60vw" onClose={onModalClose}>
        <Modal.Header title="GPT Vision Playground" />
        <Modal.Body>
          <div className={classes.contentContainer}>{content}</div>
          {metricsId && <GPTVisionCost metricsId={metricsId} />}
        </Modal.Body>
        <Modal.Footer>
          <div className={classes.footer}>
            <AttachmentList
              value={attachments}
              updateInputField={value =>
                setAttachments(_.get(value, "attachments", []))
              }
              isShowIconsInBar={true}
              showV2Icons={true}
              label={"Images"}
              name={"attachments"}
              parentType={"CIRCULAR"}
              parentId={"123"}
              accept={[
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/gif",
                "image/bmp",
                "image/tiff",
                "image/svg",
                "image/svg+xml",
                "image/webp",
                "image/heic",
                "image/heif",
              ]}
              customDropZoneStyle={_.get(styles, "customDropZone", {})}
              dropDownOptions={[
                { key: "upload_device", label: "upload_device" },
              ]}
              attachmentContainerStyle={_.get(
                styles,
                "attachmentContainer",
                {}
              )}
              showDeleteButtonForNewUploads={true}
              cardType={"design-media-card"}
              showDeleteForSelfInViewMode={true}
              showRenameAttachmentOption={false}
              showLocalAttachmentsInViewMode={false}
            />
            <div className={classes.textAreaInputContainer}>
              <TextAreaInput
                value={query}
                size={"large"}
                placeholder={"Start typing..."}
                onChange={e => setQuery(e.target.value)}
                style={styles.textAreaInput}
                minRows={1}
                maxRows={5}
                onKeyDown={onKeyDown}
              />

              <div className={classes.footerRightButtons}>
                <IconButton
                  size={"small"}
                  variant={"progressive"}
                  icon={<SendFilled variant={"on"} />}
                  onClick={onSendMessage}
                  disabled={!query}
                />
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      {isLoading && (
        <FullScreenLoader overlayContainer={classes.overlayContainer} />
      )}
    </>
  );
};

const mapActionCreators = {
  getAIResponse,
};

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, mapActionCreators)(GPTVision);
